import React, { useMemo } from 'react'
import Modal from '@/components/Modal'
import { useFormik } from 'formik'
import { FormControlLabel, Radio, RadioGroup, TextField } from '@material-ui/core'
import { useTranslation } from '@/langs/useTranslation'
import { DateTimePicker } from '@material-ui/pickers'
import dayjs from 'dayjs'
import {toast} from "@/apis/request";

const ReleaseTimeModal = ({open, onClose, onConfirm}) => {
    const { t } = useTranslation()
    const minDate = useMemo(() => {
        return dayjs().add(1, 'day').endOf('day').toDate()
    }, [])
    const { values, handleChange, setFieldValue} = useFormik({
        initialValues: {releaseNow: "1", releaseDate: minDate},
    });
    const handleDateChange = (a) => {
      // setFieldValue("releaseDate", dayjs(a).endOf('day').toDate())
      setFieldValue("releaseDate", dayjs(a).second(0).toDate())
    }
    const handleConfirm = () => {
        if (values.releaseDate.valueOf() - Date.now() < (1000*60*60*24)) {
            toast.error(t({defaultMessage: "发布时间必须在24小时后"}))
            return
        }
        if (values.releaseNow === "1") onConfirm(Date.now())
        else onConfirm(values.releaseDate.valueOf())
    }
    return (
        <Modal
          open={open}
          onClose={onClose}
          onConfirm={handleConfirm}
        >
            <RadioGroup
                aria-label="date"
                name="releaseNow"
                value={values.releaseNow}
                onChange={handleChange}
            >
                <FormControlLabel value="1" control={<Radio color="primary" />} label={t({defaultMessage: "立即发布"})} />
                <FormControlLabel value="2" control={<Radio color="primary" />} label={t({defaultMessage: "选择发布时间（设备执行时间）"})} />
            </RadioGroup>
            { values.releaseNow === "2" && (
                <DateTimePicker
                  name="releaseDate"
                  value={values.releaseDate}
                  renderInput={(params) => <TextField {...params} />}
                  inputFormat="YYYY/MM/DD HH:mm"
                  onChange={handleDateChange}
                  minDate={minDate}
                />
            )}
        </Modal>
    )
}

export default ReleaseTimeModal